module.exports = __webpack_public_path__ + "static/media/Statistics.328b00f4.png";